module.exports = __webpack_public_path__ + "static/elizar_dryflagon-afa07dd4b336890658ed65282dfa9140.jpeg";